const operation = {
  // 操作记录
  record: `/userApi/v1/Operation/record`,
  // 用户行为记录
  footprint: `/userApi/v1/Operation/footprint`,
  footprintV2: `/footprintApi/api/Operation/footprint`,
  // 广告数据点击记录
  addAdClick: `/userApi/v1/AdData/addAdClick`,
  // 新游推荐埋点
  newGameBuriedPoint: `/pcApi/v1/homeapi/Gameindex/newGameBuriedPoin`,
  // 用户行为打点 --- 林晨飞
  userClick: `/footprintApi/api/User/userClick`
};

export default operation;
